import moment, { Moment } from 'moment';

export function getDays(viewMonth: number, viewYear: number): Moment[] {
    const firstDate = moment().set({
        year: viewYear,
        month: viewMonth,
        date: 1,
    });

    while (firstDate.day() !== 0) {
        firstDate.subtract(1, 'day');
    }

    const days: Moment[] = [];
    const count = 42;

    for (let i = 0; i < count; i++) {
        days.push(firstDate.clone());
        firstDate.add(1, 'day');
    }

    return days;
}
